import { defineComponent as B, computed as E, ref as u, reactive as j, watch as d, onMounted as T, onBeforeUnmount as $, createElementBlock as f, openBlock as v, Fragment as w, createElementVNode as o, normalizeStyle as x, createCommentVNode as q, withModifiers as b, toDisplayString as k, renderList as P, normalizeClass as z } from "vue";
import { EditorClasses as A } from "@scalar-org/css";
const H = { class: "container" }, M = {
  key: 0,
  class: "level-1"
}, N = ["id"], D = ["href", "onClick"], R = /* @__PURE__ */ B({
  __name: "TableOfContents",
  props: {
    headings: {},
    pageTitle: {}
  },
  setup(I) {
    const h = I, m = E(
      () => Object.values(h.headings || {}).filter((e) => e.level === 1 || e.level === 2 || e.level === 3).map((e) => e.slug)
    ), r = u(""), a = u(""), l = j({}), i = E(
      () => Object.values(l).sort((e, t) => e.order - t.order)
    ), g = u([]), p = u(0);
    function C() {
      Object.keys(l).forEach((e) => {
        m.value.includes(e) || delete l[e];
      }), m.value.forEach((e, t) => {
        l[e] = {
          id: e,
          inView: l[e]?.inView ?? !1,
          order: t
        };
      });
    }
    d(m, () => C(), { immediate: !0, deep: !0 });
    const O = (e) => {
      e.forEach((t) => {
        if (l[t.target.id] && (l[t.target.id].inView = t.isIntersecting), a.value = t.target.id, !t.isIntersecting && t.target.getBoundingClientRect().top >= window.innerHeight * 0.2 && Object.values(l).every((c) => !c.inView)) {
          const c = i.value.findIndex(
            (S) => S.id === t.target.id
          );
          c >= 1 && (a.value = i.value[c - 1].id);
        }
      });
    };
    d(
      [a, i],
      () => {
        const e = i.value.find((t) => t.inView);
        if (e) {
          r.value = e.id;
          return;
        }
        if (a.value) {
          r.value = a.value;
          return;
        }
      },
      { immediate: !0, deep: !0 }
    );
    let s;
    function y() {
      s && s.disconnect(), document.querySelectorAll(
        '[data-scalar-type="heading"][data-level="1"], [data-scalar-type="heading"][data-level="2"], [data-scalar-type="heading"][data-level="3"]'
      ).forEach((t) => s?.observe(t));
    }
    T(() => {
      s = new IntersectionObserver(O, {
        // threshold: 1,
        // rootMargin: '-20%',
      }), y();
    }), $(() => s?.disconnect()), d(
      () => Object.keys(h.headings || {}),
      () => {
        g.value = [], y();
      }
    );
    function _(e) {
      r.value = e.parent || e.slug, window.location.replace(`#${e.slug}`), document.getElementById(e.slug)?.scrollIntoView();
    }
    function V() {
      document.querySelector(`.${A.PageTitle} h1`)?.scrollIntoView();
    }
    return d(r, () => {
      const e = g.value.find(
        (t) => t.querySelector(".anchor")?.getAttribute("href") === `#${r.value}`
      );
      e && (p.value = e.offsetTop);
    }), (e, t) => (v(), f(w, null, [
      t[0] || (t[0] = o("h4", null, "On This Page", -1)),
      o("div", H, [
        o("div", {
          class: "outline-marker",
          style: x({
            transform: `translateY(${p.value}px)`
          })
        }, null, 4),
        o("ul", null, [
          Object.keys(e.headings || {}).length === 0 ? (v(), f("li", M, [
            o("a", {
              class: "anchor",
              href: "#",
              onClick: b(V, ["prevent"])
            }, k(e.pageTitle), 1)
          ])) : q("", !0),
          (v(!0), f(w, null, P(e.headings, (n) => (v(), f("li", {
            id: n.uid,
            key: n.uid,
            ref_for: !0,
            ref_key: "tocItems",
            ref: g,
            class: z([
              `level-${n?.level}`,
              { active: r.value === n.slug }
            ])
          }, [
            o("a", {
              class: "anchor",
              href: `#${n.slug}`,
              onClick: b(() => _(n), ["prevent"])
            }, k(n.name), 9, D)
          ], 10, N))), 128))
        ])
      ])
    ], 64));
  }
});
export {
  R as default
};
